import React, { useState } from 'react';
import Icon from '@/components/UI/icon/Icon';
import Button from '@/components/UI/button/Button';
import Box from '@/components/UI/box/Box';
import IncrementStepper from '@/components/reusable/incrementStepper/IncrementStepper';
import styles from './GuestCountMobile.module.scss';
import Typography from '@/components/UI/typography/Typography';
type IGuestCountMobile = {
  value: number | string;
  setValue: (value: number) => void;
  submitData: (count: number) => void;
  resetFilter: (e: React.FormEvent, shouldClose?: boolean) => void;
  onClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
  hasGuestCount: boolean;
};
const GuestCountMobile = ({
  onClose,
  value,
  setValue,
  submitData,
  resetFilter,
  hasGuestCount
}: IGuestCountMobile) => {
  const [count, setCount] = useState(+value);
  const handleChange = (type: string) => {
    if (type === 'increase') {
      setCount(+count + 1);
    }
    if (type === 'decrease') {
      setCount(+count - 1);
    }
  };
  return <Box className={styles['guest-count-mobile-container']} data-sentry-element="Box" data-sentry-component="GuestCountMobile" data-sentry-source-file="GuestCountMobile.tsx">
      <Box className={styles['guest-count-header']} data-sentry-element="Box" data-sentry-source-file="GuestCountMobile.tsx">
        <Box onClick={onClose} className="close-icon-section" data-sentry-element="Box" data-sentry-source-file="GuestCountMobile.tsx">
          <Icon name="close" type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="GuestCountMobile.tsx" />
        </Box>
        <Typography variant="title_Bold" data-sentry-element="Typography" data-sentry-source-file="GuestCountMobile.tsx">تعداد نفرات</Typography>
      </Box>
      <Box className={styles['increment-stepper-section']} data-sentry-element="Box" data-sentry-source-file="GuestCountMobile.tsx">
        <IncrementStepper format="base" label="نفر" value={+count} handleChange={handleChange} minimumValue={1} maximumValue={100} data-sentry-element="IncrementStepper" data-sentry-source-file="GuestCountMobile.tsx" />
      </Box>
      <Box className={styles['submit-guest-count-button']} data-sentry-element="Box" data-sentry-source-file="GuestCountMobile.tsx">
        <Button format="text" onClick={resetFilter} data-sentry-element="Button" data-sentry-source-file="GuestCountMobile.tsx">
          پاک کردن
        </Button>
        <Button format="primary" onClick={() => {
        setValue(+count);
        submitData(count);
      }} data-sentry-element="Button" data-sentry-source-file="GuestCountMobile.tsx">
          ثبت تعداد نفرات
        </Button>
      </Box>
    </Box>;
};
export default GuestCountMobile;